"use client";

import { useEffect, useState } from "react";

const useCookie = (name: string = "location") => {
  const [cookie, setCookie] = useState<string>();

  useEffect(() => {
    fetch(`/api/get-cookie/?name=${name}`, {
      next: { revalidate: 60 },
    })
      .then((res) => res.json())
      .then((data) => {
        setCookie(data.value);
      });
  }, [name]);

  return cookie;
};

export default useCookie;
